const global = {
    // 表单必输项
    requiredRule: {
        required: true,
        message: '该项为必输项！',
        trigger: ['blur', 'change'],
    },
    // 文件上传接口
    uploadURL: process.env.VUE_APP_BASE_API + '/file/temp',

    // 码值转换
    getNameByCode: (codeInfo, codeValue) => {
        if (!codeInfo) {
            return codeValue
        }

        if (codeValue == undefined) {
            return ''
        }

        let codeName = ''
        for (let i = 0; i < codeInfo.length; i++) {
            if (codeValue == codeInfo[i].value) {
                codeName = codeInfo[i].content
                break
            }
        }
        return codeName == '' ? codeValue : codeName
    },
    // 分转元
    regFenToYuan: val => {
        let num = Number(val)
        if (!isNaN(num)) {
            num = num * 0.01 + ''
            let reg = num.indexOf('.') > -1 ? /(\d{1,3})(?=(?:\d{3})+\.)/g : /(\d{1,3})(?=(?:\d{3})+$)/g //千分符的正则
            return num.replace(reg, '$1,')
        } else {
            return null
        }
    },
    //加
    accAdd: (arg1, arg2) => {
        var r1, r2, m
        try {
            r1 = arg1.toString().split('.')[1].length
        } catch (e) {
            r1 = 0
        }
        try {
            r2 = arg2.toString().split('.')[1].length
        } catch (e) {
            r2 = 0
        }
        m = Math.pow(10, Math.max(r1, r2))
        return (arg1 * m + arg2 * m) / m
    },

    //减
    accSub: (arg1, arg2) => {
        var r1, r2, m, n
        try {
            r1 = arg1.toString().split('.')[1].length
        } catch (e) {
            r1 = 0
        }
        try {
            r2 = arg2.toString().split('.')[1].length
        } catch (e) {
            r2 = 0
        }
        m = Math.pow(10, Math.max(r1, r2))
            // 动态控制精度长度
        n = r1 >= r2 ? r1 : r2
        return ((arg1 * m - arg2 * m) / m).toFixed(n)
    },

    //乘
    accMul: (arg1, arg2) => {
        var m = 0,
            s1 = arg1.toString(),
            s2 = arg2.toString()
        try {
            m += s1.split('.')[1].length
        } catch (e) {
            //异常继续
        }
        try {
            m += s2.split('.')[1].length
        } catch (e) {
            //异常继续
        }
        return (Number(s1.replace('.', '')) * Number(s2.replace('.', ''))) / Math.pow(10, m)
    },

    //除
    accDiv: (arg1, arg2) => {
        var t1 = 0,
            t2 = 0,
            r1,
            r2
        try {
            t1 = arg1.toString().split('.')[1].length
        } catch (e) {
            //异常继续
        }
        try {
            t2 = arg2.toString().split('.')[1].length
        } catch (e) {
            //异常继续
        }
        r1 = Number(arg1.toString().replace('.', ''))
        r2 = Number(arg2.toString().replace('.', ''))
        return (r1 / r2) * Math.pow(10, t2 - t1)
    },

    // Date => String
    getDate: (date = new Date(), split = '-') => new Date(date).toLocaleDateString().replaceAll('/', split),

    // 获得当前日期前后N天日期
    getDateStr(AddDayCount) {
        const dd = new Date()
        dd.setDate(dd.getDate() + AddDayCount) //获取AddDayCount天后的日期
        const y = dd.getFullYear()
        const m = dd.getMonth() + 1 < 10 ? '0' + (dd.getMonth() + 1) : dd.getMonth() + 1 //获取当前月份的日期，不足10补0
        const d = dd.getDate() < 10 ? '0' + dd.getDate() : dd.getDate() //获取当前几号，不足10补0
        return y + '-' + m + '-' + d
    },

    // 滚动到页面顶部
    scrollToTop: () => {
        const c = document.documentElement.scrollTop || document.body.scrollTop
        if (c > 0) {
            window.requestAnimationFrame(scrollToTop)
            window.scrollTo(0, c - c / 8)
        }
    },

    // 获取URL内的参数
    getURLParameters: url =>
        (url.match(/([^?=&]+)(=([^&]*))/g) || []).reduce(
            (a, v) => ((a[v.slice(0, v.indexOf('='))] = v.slice(v.indexOf('=') + 1)), a), {},
        ),

    // 复制字符串到剪切板
    copyToClipboard: str => {
        const el = document.createElement('textarea')
        el.value = str
        el.setAttribute('readonly', '')
        el.style.position = 'absolute'
        el.style.left = '-9999px'
        document.body.appendChild(el)
        const selected = document.getSelection().rangeCount > 0 ? document.getSelection().getRangeAt(0) : false
        el.select()
        document.execCommand('copy')
        document.body.removeChild(el)
        if (selected) {
            document.getSelection().removeAllRanges()
            document.getSelection().addRange(selected)
        }
    },
    getLanguage(name,status) {
        if (localStorage.getItem("language")) {
            const a = JSON.parse(localStorage.getItem("language")).filter(o => o.LANGUAGE_ID == name)
            if (a.length>0) {
                if (status == 2) {
                    return a[0].NAME
                }
                return a[0].Title
            }
        }
    },
    getName(name,status){
        var a = JSON.parse(localStorage.getItem("language"));
        // var b = [];
        // a.forEach(element => {
        //     if (element.NAME === name) {
        //         b.push(element);
        //     }
        // });
        var b = a.filter((m) =>
            m.NAME == name
        )
        if (b[0] != undefined) {
            var  c =  localStorage.getItem('languageSet')
            if (status == 1) {
                return b[0].EN_TITLE;
            }
            // if (status == 2) {
            //     return b[1].EN_TITLE;
            // }
            if (c == 'zh') {
                return b[0].ZH_TITLE
            }
            return b[0].EN_TITLE
        }else{
            return null;
        }
    },
    getSystemError(){
        this.getLanguage("REMINDER_SYSTEM_ERROR");
    }


}

export default global
